import { render, staticRenderFns } from "./SiloCardOverviewComponent.vue?vue&type=template&id=1c1e78a8&"
import script from "./SiloCardOverviewComponent.vue?vue&type=script&lang=js&"
export * from "./SiloCardOverviewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports